"use client";

import { useEffect, useState } from "react";

export default function ThemeToggle() {
  const [isLight, setIsLight] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "light") {
      document.body.classList.add("theme-light");
      setIsLight(true);
    }
  }, []);

  const toggleTheme = () => {
    if (isLight) {
      document.body.classList.remove("theme-light");
      localStorage.setItem("theme", "dark");
      setIsLight(false);
    } else {
      document.body.classList.add("theme-light");
      localStorage.setItem("theme", "light");
      setIsLight(true);
    }
  };

  return (
    <label className="switch">
      <input 
        type="checkbox" 
        role="switch"
        checked={!isLight} 
        onChange={toggleTheme} 
        aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}
      />
      <span className="slider round"></span>
    </label>
  );
}
